import REDUX_DOMAIN from '../../constants/domain'
import getClassNameReduxUtil from '../get-class-name'
import { logUtil } from 'packages/src'

export default function getDomainPathReduxUtil (instance) {
  const className = getClassNameReduxUtil(instance)
  const domainPath = REDUX_DOMAIN[className]
  if (!domainPath) {
    logUtil('getDomainPathReduxUtil').warn('[notFound] instance=', instance)
  }
  return domainPath
}
